import React, { Component } from 'react'
import _ from 'lodash'

import { configString } from 'containers/Form/Memory/constants'
import { updateModuleData } from 'helpers/specHelpers'
import ListSpec from 'containers/Project/ListSpec/index'

class MemorySpec extends Component {
  combineData(dataArr) {
    const configs = {}
    const newDataArr = []

    dataArr.forEach((data, index) => {
      const {
        organizationSize,
        organizationWidth,
        partType,
        density,
        rvlId,
        vendorName,
        partNumber,
        risk,
      } = data
      const config = data.config ? data.config : configString(partType, organizationSize, organizationWidth, density)
      const memoryPart = `${rvlId ? 'RVL' : 'Non RVL'}: ${vendorName} ${partNumber}`

      if (configs[config]) {
        configs[config].item.push(memoryPart)
        configs[config].risks.push(risk)
      } else {
        configs[config] = {
          memConfig: `${organizationSize}Mx${organizationWidth} ${partType}`,
          item: [memoryPart],
          risks: [risk],
          ...data
        }
      }
    })

    return Object.values(configs)
  }

  render() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props
    const memoryData = moduleData['memory']
    if(!memoryData) return null

    const newModuleData = updateModuleData(_.cloneDeep(memoryData), this.combineData)

    return (
      <ListSpec
        moduleName={ 'memory' }
        moduleData={ newModuleData }
        isModifiedPage={ isModifiedPage }
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
      />
    )
  }
}

export default MemorySpec
